import { render, staticRenderFns } from "./Wave.vue?vue&type=template&id=df85ed74&scoped=true"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"
import style0 from "./Wave.vue?vue&type=style&index=0&id=df85ed74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df85ed74",
  null
  
)

export default component.exports